import { render } from "./AposLabel.vue?vue&type=template&id=16d32d86&scoped=true"
import script from "./AposLabel.vue?vue&type=script&lang=js"
export * from "./AposLabel.vue?vue&type=script&lang=js"

import "./AposLabel.vue?vue&type=style&index=0&id=16d32d86&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d32d86"],['__file',"ui/ui/apos/components/AposLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16d32d86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16d32d86', __exports__)) {
    api.reload('16d32d86', __exports__)
  }
  
  module.hot.accept("./AposLabel.vue?vue&type=template&id=16d32d86&scoped=true", () => {
    api.rerender('16d32d86', render)
  })

}


export default __exports__